module.exports = __webpack_public_path__ + "static/img/waiting.df6b66ee.png";